const useIsReview = (): boolean => {
	return false;
};

export default useIsReview;
